import * as Yup from 'yup';
/* eslint-disable no-useless-escape */
import {
  zipRegexValidation,
  fullDateRegexValidation,
  phoneNumberRegexValidation
} from 'modules/utils/MaskUtils';
import dayjs from 'dayjs';

export const COVID_AUTH_SCREENING_PERSONAL_INFO_BODY_2_OTP = `. If you change your phone number, we will send a one-time passcode to your phone for verification. `;

export const COVID_SCREENING_PERSONAL_INFO_BODY_1 = `The information you provide is used to locate your Intermountain record and `;

export const COVID_SCREENING_PERSONAL_INFO_BODY_2 = `contact you with test results`;

export const COVID_SCREENING_PERSONAL_INFO_BODY_2_OTP = `. We will send a one-time passcode to your phone number for verification. `;

export const COVID_SCREENING_PERSONAL_INFO_BODY_3 = `. Your mobile phone, email address, and insurance will be updated. Contact us at 385-297-6430 if updates are needed to your physical/mailing address.`;

export const COVID_SCREENING_PERSONAL_INFO_BODY_3B_OTP = `Your mobile phone, email address, and insurance will be updated. Contact us at 385-297-6430 if updates are needed to your physical/mailing address.`;

export const COVID_SCREENING_PERSONAL_INFO_BODY_3_OTP_MOBILE = `. If you update your phone number, we will send a one-time passcode to your phone number for verification`;

export const COVID_SCREENING_LEGAL_SEX_TEXT = `This is the legal sex marker on your insurance/health record/drivers license, which may differ from your current gender identity.`;

export const OTP_EMAIL_ERROR_1 = `We could not validate the email `;

export const OTP_EMAIL_ERROR_2 = `. Please verify you entered your email correctly.`;

export const OTP_PHONE_ERROR_1 = `We could not send a one-time passcode to `;

export const OTP_PHONE_ERROR_2 = `. Please verify you entered your phone number correctly.`;

export const OTP_MAX_PIN_AUTH_ERROR = `The one-time passcode limit has been reached with this session. Please wait 1-2 minutes, and try again.`;

export const OTP_MAX_PIN_UNAUTH_ERROR = `The one-time passcode limit has been reached with this session. Please wait 15 minutes, and try again.`;

export const OTP_OTHER_ERROR = `A one-time passcode error occurred, please try again.`;

export const SEX_OPTIONS = [
  { label: 'Male', value: 'MALE' },
  { label: 'Female', value: 'FEMALE' },
  { label: 'Both', value: 'BOTH' },
  { label: 'Unknown', value: 'UNKNOWN' }
];

export const SEX_OPTIONS_TRANSLATED = (screenText: object = {}) => [
  { label: screenText.male, value: 'MALE' },
  { label: screenText.female, value: 'FEMALE' },
  { label: screenText.both, value: 'BOTH' },
  { label: screenText.unknown, value: 'UNKNOWN' }
];

export const RelationShipToSubscriber = [
  { label: 'Self', value: 'Self' },
  { label: 'Spouse', value: 'Spouse' },
  { label: 'Child', value: 'Child' },
  { label: 'Stepchild', value: 'Stepchild' },
  { label: 'Grandchild', value: 'Grandchild' },
  { label: 'Life Partner', value: 'Life Partner' },
  { label: 'Overage Dependent', value: 'Overage Dependent' },
  { label: 'Other', value: 'Other' }
];

export interface SexOptionsType {
  label: string;
  value: string;
}

export interface StateOptionsType {
  label: string;
  value: string;
}

export const submitPersonalInfoValidation = Yup.object().shape({
  userFirstName: Yup.string()
    .max(16, 'Please use 16 characters or less')
    .required('Please enter a valid first name'),
  userMiddleName: Yup.string()
    .max(16, 'Please use 16 characters or less')
    .notRequired(),
  userLastName: Yup.string()
    .max(26, 'Please use 26 characters or less')
    .required('Please enter a valid last name'),
  userSex: Yup.string().required('Please select a gender'),
  userDateOfBirth: Yup.string()
    .matches(fullDateRegexValidation, 'Must be exactly 8 digits')
    .required('Please enter a valid date of birth'),
  userSSNDigits: Yup.number()
    .typeError('Please enter valid number')
    .notRequired(),
  userAddressLine1: Yup.string()
    .max(30, 'Please use 30 characters or less')
    .required('Please enter line 1 of your address'),
  userAddressLine2: Yup.string()
    .max(30, 'Please use 30 characters or less')
    .notRequired(),
  userCity: Yup.string()
    .max(34, 'Please use 34 characters or less')
    .required('Please enter a city'),
  userZip: Yup.string()
    .required('Please enter a valid zip code')
    .matches(zipRegexValidation, 'Must be a valid zip'),
  userState: Yup.string().required('Please select valid State'),
  userEmail: Yup.string()
    .required('Please enter a valid email address')
    .email('Please enter a valid email'),
  userCellNumber: Yup.string()
    .required('Please enter a valid phone number')
    .matches(phoneNumberRegexValidation, 'Must be exactly 10 digits'),
  userOtherPhoneNumber: Yup.string()
    .notRequired()
    .matches(phoneNumberRegexValidation, 'Must be exactly 10 digits')
});

export interface FormValues {
  userFirstName: string;
  userMiddleName: string;
  userLastName: string;
  userDateOfBirth: string;
  userSSNDigits: string;
  userSex: string;
  userAddressLine1: string;
  userAddressLine2: string;
  userCity: string;
  userState: string;
  userZip: string;
  userEmail: string;
  userCellNumber: string;
  userOtherPhoneNumber: string;
  userHasNoCellNumber?: boolean;
}
export const submitSubscriberInfoValidation = Yup.object().shape({
  subscriberFirstName: Yup.string()
    .max(16, 'Please use 16 characters or less')
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .required('Please enter a valid first name'),
  subscriberMiddleName: Yup.string()
    .max(16, 'Please use 16 characters or less')
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .notRequired(),
  subscriberLastName: Yup.string()
    .max(26, 'Please use 26 characters or less')
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .required('Please enter a valid last name'),
  subscriberSex: Yup.string().required('Please select gender'),
  subscriberAddressLine1: Yup.string()
    .max(30, 'Please use 30 characters or less')
    .required('Please enter line 1 of your address'),
  subscriberAddressLine2: Yup.string()
    .max(30, 'Please use 30 characters or less')
    .notRequired(),
  subscriberCity: Yup.string()
    .max(34, 'Please use 34 characters or less')
    .required('Please enter a city'),
  subscriberZip: Yup.string()
    .required('Please enter a valid zip code')
    .matches(zipRegexValidation, 'Must be a valid zip'),
  subscriberState: Yup.string().required('Please select a valid state'),
  subscriberEmail: Yup.string()
    .required('Please enter a valid email address')
    .email('Please enter a valid email'),
  subscriberCellNumber: Yup.string()
    .required('Please enter a valid phone number')
    .matches(phoneNumberRegexValidation, 'Must be exactly 10 digits'),
  subscriberDateOfBirth: Yup.date().required('Subscriber D.O.B is required')
});

export const submitSubscriberInfoValidationGuest = (screenText: object = {}) => {
  return Yup.object().shape({
    subscriberFirstName: Yup.string()
      .max(16, screenText.error_16_characters)
      .matches(/^[a-zA-Z-]*$/, screenText.error_no_numbers)
      .required(screenText.error_first_name),
    subscriberMiddleName: Yup.string()
      .max(16, screenText.error_16_characters)
      .matches(/^[a-zA-Z-]*$/, screenText.error_no_numbers)
      .notRequired(),
    subscriberLastName: Yup.string()
      .max(26, screenText.error_26_characters)
      .matches(/^[a-zA-Z-]*$/, screenText.error_no_numbers)
      .required(screenText.error_last_name),
    subscriberSex: Yup.string().required(screenText.error_select_gender),
    subscriberAddressLine1: Yup.string()
      .max(30, screenText.error_30_characters)
      .required(screenText.error_address_1),
    subscriberAddressLine2: Yup.string()
      .max(30, screenText.error_30_characters)
      .notRequired(),
    subscriberCity: Yup.string()
      .max(34, screenText.error_34_characters)
      .required(screenText.error_city),
    subscriberZip: Yup.string()
      .required(screenText.error_zip)
      .matches(zipRegexValidation, screenText.error_valid_zip),
    subscriberState: Yup.string().required(screenText.error_state),
    subscriberEmail: Yup.string()
      .required(screenText.error_email)
      .email(screenText.error_valid_email),
    subscriberCellNumber: Yup.string()
      .required(screenText.error_phone)
      .matches(phoneNumberRegexValidation, screenText.error_phone_format),
    subscriberDateOfBirth: Yup.string()
      .nullable(true)
      .test('invalid-dob', screenText.error_birthdate_format, function(value: string) {
        return dayjs(value).isValid();
      })
      .test('dob-after-max-date', screenText.error_birthdate, function(value: string) {
        return dayjs().isAfter(value);
      })
      .test('test-patient-dob', screenText.error_birthdate_format, function(value: string) {
        return dayjs().diff(dayjs(value), 'month') >= 3;
      })
      .required(screenText.error_birthdate)
  });
};

export const submitGuestPersonalInfoValidation = Yup.object().shape({
  userFirstName: Yup.string()
    .max(16, 'Please use 16 characters or less')
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .required('Please enter a valid first name'),
  userMiddleName: Yup.string()
    .max(16, 'Please use 16 characters or less')
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .notRequired(),
  userLastName: Yup.string()
    .max(26, 'Please use 26 characters or less')
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .required('Please enter a valid last name'),
  userDateOfBirth: Yup.string()
    .nullable(true)
    .test('invalid-dob', 'Please enter valid date of birth', function(value: string) {
      return dayjs(value).isValid();
    })
    .test('dob-after-max-date', 'Please enter a valid date', function(value: string) {
      return dayjs().isAfter(value);
    })
    .test(
      'test-patient-dob',
      'If your child is less than three months and having symptoms, call your pediatrician or visit an Intermountain InstaCare/KidsCare for evaluation.',
      function(value: string) {
        return dayjs().diff(dayjs(value), 'month') >= 3;
      }
    )
    .required('Please enter a valid date of birth'),
  userSex: Yup.string().required('Please select a gender'),
  userSSNDigits: Yup.number()
    .typeError('Please enter valid number')
    .notRequired(),
  userAddressLine1: Yup.string()
    .max(30, 'Please use 30 characters or less')
    .required('Please enter line 1 of your address'),
  userAddressLine2: Yup.string()
    .max(30, 'Please use 30 characters or less')
    .notRequired(),
  userCity: Yup.string()
    .max(34, 'Please use 34 characters or less')
    .required('Please enter a city'),
  userZip: Yup.string()
    .required('Please enter a valid zip code')
    .matches(zipRegexValidation, 'Must be a valid zip'),
  userState: Yup.string().required('Please select valid State'),
  userEmail: Yup.string()
    .required('Please enter a valid email address')
    .email('Please enter a valid email'),
  userCellNumber: Yup.string().when('userHasNoCellNumber', {
    is: true,
    then: Yup.string().notRequired(),
    otherwise: Yup.string()
      .required('Please enter a valid phone number')
      .matches(phoneNumberRegexValidation, 'Must be exactly 10 digits')
  }),
  userHasNoCellNumber: Yup.boolean(),
  userOtherPhoneNumber: Yup.string().when('userHasNoCellNumber', {
    is: false,
    then: Yup.string().notRequired(),
    otherwise: Yup.string()
      .required('Please enter a valid phone number')
      .matches(phoneNumberRegexValidation, 'Must be exactly 10 digits')
  })
});

export const submitGuestPersonalInfoValidationLocalized = (screenText: object = {}) => {
  return Yup.object().shape({
    userFirstName: Yup.string()
      .max(16, screenText.field_1_err_1)
      .matches(/^[a-zA-ZÀ-ÿ\s]+$/, screenText.no_special_char)
      .required(screenText.field_1_err_2),
    userMiddleName: Yup.string()
      .max(16, screenText.field_2_err_1)
      .matches(/^[a-zA-ZÀ-ÿ\s]+$/, screenText.no_special_char)
      .notRequired(),
    userLastName: Yup.string()
      .max(26, screenText.field_3_err_1)
      .matches(/^[a-zA-ZÀ-ÿ\s]+$/, screenText.no_special_char)
      .required(screenText.field_3_err_2),
    userDateOfBirth: Yup.string()
      .nullable(true)
      .test('invalid-dob', screenText.field_4_err_2, function(value: string) {
        return dayjs(value).isValid();
      })
      .test('dob-after-max-date', screenText.field_4_err_4, function(value: string) {
        return dayjs().isAfter(value);
      })
      .test('test-patient-dob', screenText.field_4_err_1, function(value: string) {
        return dayjs().diff(dayjs(value), 'month') >= 3;
      })
      .required(screenText.field_4_err_4),
    userSex: Yup.string().required(screenText.field_5_err_1),
    userSSNDigits: Yup.number()
      .typeError(screenText.field_6_err_1)
      .notRequired(),
    userAddressLine1: Yup.string()
      .max(30, screenText.field_7_err_1)
      .required(screenText.field_7_err_2),
    userAddressLine2: Yup.string()
      .max(30, screenText.field_8_err_1)
      .notRequired(),
    userCity: Yup.string()
      .max(34, screenText.field_9_err_1)
      .required(screenText.field_9_err_2),
    userZip: Yup.string()
      .required(screenText.field_11_err_1)
      .matches(zipRegexValidation, screenText.field_11_err_2),
    userState: Yup.string().required(screenText.field_10_err_1),
    userEmail: Yup.string()
      .required(screenText.field_12_err_1)
      .email(screenText.field_12_err_2),
    userCellNumber: Yup.string().when('userHasNoCellNumber', {
      is: true,
      then: Yup.string().notRequired(),
      otherwise: Yup.string()
        .required(screenText.field_13_err_1)
        .matches(phoneNumberRegexValidation, screenText.field_13_err_2)
    }),
    userHasNoCellNumber: Yup.boolean(),
    userOtherPhoneNumber: Yup.string().when('userHasNoCellNumber', {
      is: false,
      then: Yup.string().notRequired(),
      otherwise: Yup.string()
        .required(screenText.field_14_err_1)
        .matches(phoneNumberRegexValidation, screenText.field_14_err_2)
    })
  });
};

export const getRelationTranslated = (relation: string, screenText: object = {}) => {
  if (screenText[relation]) return screenText[relation];
  switch (relation) {
    case 'Self':
      return screenText.self;
    case 'Spouse':
      return screenText.spouse;
    case 'Child':
      return screenText.child;
    case 'Stepchild':
      return screenText.stepchild;
    case 'Grandchild':
      return screenText.grandchild;
    case 'Life Partner':
      return screenText.lifePartner;
    case 'Overage Dependent':
      return screenText.overageDependent;
    case 'Other':
      return screenText.other;
    default:
      break;
  }
  return '';
};
